import t from "react";
const e = t.createContext({
  collapse: !0,
  rootClassName: ""
}), a = () => t.useContext(e);
export {
  e as VerticalNavigationContext,
  a as useVerticalNavigationContext
};
